module.exports = __webpack_public_path__ + "static/img/d_xieyi.a3170fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/d_xieyi.png
// module id = /Gp2
// module chunks = 69